/* istanbul ignore file */
import { APP_ROOT_ELEMENT_ID, CONFIG_ELEMENT_ID } from './constants';
async function init() {
  // TODO -- Currently slightly modified logic. Maybe align with default during time.
  const configElement = document.getElementById(CONFIG_ELEMENT_ID);
  if (!configElement) {
    throw new Error(`Element #${CONFIG_ELEMENT_ID} was not found!`);
  }
  let rootElement = document.getElementById(APP_ROOT_ELEMENT_ID);
  if (!rootElement) {
    rootElement = document.createElement('div');
    rootElement.setAttribute('id', APP_ROOT_ELEMENT_ID);
    document.body.append(rootElement);
  }
  const appRender = await import('./appRender');
  void appRender.render(configElement, rootElement);
}
init().catch(error => {
  throw error;
});